import React from "react";

export function CoverLetterPreview({ data, language }) {
  const L = language === "fr"
    ? { empty: "La lettre de motivation s'affichera ici après génération." }
    : { empty: "Your cover letter will appear here after generation." };

  if (!data) {
    return (
      <div className="a4-page flex items-center justify-center" data-testid="cl-preview-empty">
        <p className="text-sm text-[#6b7280] italic text-center max-w-[60%]">{L.empty}</p>
      </div>
    );
  }

  const h = data.header || {};
  const recipient = data.recipient || {};
  const paragraphs = data.paragraphs || {};
  const contact = [h.email, h.phone, h.location, h.linkedin].filter(Boolean).join(" | ");

  return (
    <div className="a4-page" data-testid="cl-preview" style={{ padding: "44px 52px" }}>
      {/* Sender block */}
      <div style={{ marginBottom: 14 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: "#0a0a0a" }}>{h.full_name}</div>
        {contact && (
          <div style={{ fontSize: 10.5, color: "#525252", marginTop: 2 }}>{contact}</div>
        )}
      </div>

      {/* Recipient block (right-aligned) */}
      <div style={{ textAlign: "right", color: "#0a0a0a", fontSize: 11, lineHeight: "15px" }}>
        {[recipient.company, recipient.department, recipient.city]
          .filter(Boolean)
          .map((line, i) => (<div key={i}>{line}</div>))}
        {data.date_line && (
          <div style={{ marginTop: 6 }}>{data.date_line}</div>
        )}
      </div>

      {/* Subject */}
      {data.subject && (
        <div style={{ marginTop: 16, marginBottom: 10, fontWeight: 700, fontSize: 12 }}>
          {data.subject}
        </div>
      )}

      {/* Salutation */}
      {data.salutation && (
        <p style={{ margin: 0, fontSize: 12, lineHeight: "17px" }}>{data.salutation}</p>
      )}

      {/* Body paragraphs (Vous, Moi, Nous) */}
      {["vous", "moi", "nous"].map((key) =>
        paragraphs[key] ? (
          <p key={key} style={{ marginTop: 8, marginBottom: 0, fontSize: 12, lineHeight: "17px", textAlign: "justify" }}>
            {paragraphs[key]}
          </p>
        ) : null
      )}

      {/* Sign-off */}
      {data.signoff && (
        <p style={{ marginTop: 12, marginBottom: 0, fontSize: 12, lineHeight: "17px" }}>
          {data.signoff}
        </p>
      )}

      {/* Signature */}
      {data.signature && (
        <div style={{ marginTop: 14, fontSize: 12, fontWeight: 700 }}>{data.signature}</div>
      )}
    </div>
  );
}
